import { NavLink } from "react-router-dom"

import { TAB_NAMES, TAB_PATHS } from "../constants"
import { TABS } from "../interfaces"
import { searchIsActive } from "../helpers"
import { Service } from "../Service"
import { Community } from "../Community"

import style from "./style.module.scss"

import { DesktopNavigation } from "components/Header"
import { Icon } from "components"

interface Props {
    getPath: (path: string) => string
    isClientsFeedbackEnabled: boolean
}

export function DesktopMenu({ getPath, isClientsFeedbackEnabled }: Props) {
    return (
        <DesktopNavigation.Menu>
            {(Object.keys(TAB_NAMES) as TABS[]).map((tab) => {
                if (tab === TABS.CLIENTS_FEEDBACK && !isClientsFeedbackEnabled) return null

                return (
                    <DesktopNavigation.Item key={tab} primary={tab === TABS.CALENDAR}>
                        <NavLink
                            to={getPath(TAB_PATHS[tab])}
                            className={() =>
                                searchIsActive(tab, location.pathname) ? "is-active" : ""
                            }
                        >
                            {TAB_NAMES[tab]}
                        </NavLink>
                    </DesktopNavigation.Item>
                )
            })}
            <DesktopNavigation.Item submenu primary>
                Еще <Icon type="arrow-down-dark" />
                <DesktopNavigation.Submenu className={style.subMenu}>
                    <DesktopNavigation.SubmenuItem>
                        <Service />
                    </DesktopNavigation.SubmenuItem>
                    <DesktopNavigation.SubmenuItem>
                        <Community />
                    </DesktopNavigation.SubmenuItem>
                </DesktopNavigation.Submenu>
            </DesktopNavigation.Item>
        </DesktopNavigation.Menu>
    )
}
